import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const deleteTaskWithAmends = api(async function deleteTaskWithAmends({ projectId, scheduleId, taskId, amends }) {
    return mutate(
        gql`
            mutation DeleteTaskWithAmends(
                $projectId: String!
                $scheduleId: String!
                $taskId: String!
                $amends: JSONObject!
            ) {
                deleteTaskWithAmends(projectId: $projectId, scheduleId: $scheduleId, taskId: $taskId, amends: $amends)
            }
        `,
        {
            projectId,
            scheduleId,
            taskId,
            amends,
        },
        { returns: "deleteTaskWithAmends" }
    )
})
